import React, { useEffect, useState } from "react";
// styled components
import { Divider, Form, Input, Select, Button, Table, Popover } from "antd";
//  hook
import { useDocumentos } from "./Hooks/useDocumentos";
// icons
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalEditarDocumentos } from "../../../Admin/Beps/infoBeps/components/ModalEditarDocumentos";
import { useMaestras } from "../../../../hooks/useMaestras";
import Swal from "sweetalert2";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import DocumentInput from "../../../../utils/DocumentInput";
import ModalWarning from "../../../../utils/Alerts/ModalWarning";

interface IProps {
  cambiarPestaña: any;
  activeItem: any;
}

export const Documentos: React.FC<IProps> = (props: IProps) => {
  const { decrypt } = useEncrypt();
  const [modal_war, setModal_war] = useState(false);
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  // hook
  const {
    documento,
    setDocumento,
    documentos,
    fileInputRef,
    guardarArchivo,
    agregarfila,
    eliminarFila,
    guardarycontinuar,
    cargarConvocatoria,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisulizar,
    modaleditardocumento,
    setModalEditarDocumento,
    setIndexDocumento,
    indexdocumento,
    editarFila,
    setDocumentos,
  } = useDocumentos();

  const { documentosGenerales, obtenerDocGen } = useMaestras();

  useEffect(() => {
    cargarConvocatoria();
    obtenerDocGen();
  }, []);
  // columnas
  const columns = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <span className="font-family-Montserrat-Regular">{index + 1}</span>
        );
      },
    },
    {
      title: "Tipo de documento",
      width: 200,
      dataIndex: "tipo_documento",
      key: "tipo_documento",
    },
    {
      title: "Nombre",
      width: 200,
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Nombre archivo",
      width: 200,
      dataIndex: "url_documento",
      key: "url_documento",
      render: (data) => {
        return data ? data : "Sin adjunto";
      },
    },
    {
      title: "Descripción",
      width: 200,
      dataIndex: "descripcion",
      key: "descripcion",
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Descripción">
            {`${datos.substring(0, 24)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Acciones</div>
          <div className="col-4 justify-content-center font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 justify-content-center font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 justify-content-center font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 200,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4 justify-content-center">
            <Button
              className="button-gray-ghost"
              icon={
                <EyeOutlined
                  onClick={() => {
                    if (datos.url_documento !== "") {
                      setDocumentoVisulizar(datos.url_documento);
                      setModalVisualizarDocumento(true);
                    } else {
                      setModal_war(true);
                    }
                  }}
                />
              }
            ></Button>
          </div>
          <div className="col-4 justify-content-center">
            <Button
              className="button-gray-ghost"
              icon={
                <EditOutlined
                  onClick={() => {
                    setIndexDocumento(index);
                    setModalEditarDocumento(true);
                    setDocumento(datos);
                  }}
                />
              }
            ></Button>
          </div>
          <div className="col-4 justify-content-center">
            <Button
              className="button-gray-ghost"
              icon={
                <DeleteOutlined
                  onClick={() => {
                    Swal.fire({
                      title: "¿Estás seguro de eliminar el documento?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Sí",
                      cancelButtonText: "No",
                    }).then(async (result) => {
                      if (result.isConfirmed) {
                        eliminarFila(index);
                      }
                      if (result.isDismissed) {
                        return;
                      }
                    });
                  }}
                />
              }
            ></Button>
          </div>
        </div>
      ),
    },
  ];
  // fields
  const fields = [
    { name: "nombre", value: documento.nombre },
    { name: "tipo_documento", value: documento.tipo_documento },
    { name: "descripcion", value: documento.descripcion },
    { name: "url_documento", value: documento.url_documento },
  ];

  const onAceptar = () => {
    return setModal_war(false);
  };

  return (
    <>
      <div className="ontainer-fluid ps-md-4 pe-md-4 main-c7">
        <div className="row-shadow mt-3 mb-3">
          <div className="container-row-shadow">
            <div className="row">
              <div className="col-12 col-md-8 pb-2 font-size-14px font-family-Montserrat-Regular">
                Documentación general convocatoria jurados
              </div>
              <div className="col-8 col-md-4 pb-2 d-flex justify-content-md-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular">
                Código de convocatoria: {idConvocatoria}
              </div>
            </div>
            <Divider className="no-margin" />
            <Form
              name="documentosconvocatoriajurados"
              size="large"
              layout="vertical"
              className="width-100"
              onFinish={agregarfila}
              fields={fields}
              onFieldsChange={(_, fields: any) => {
                let infoupdate: any = { ...documento };
                for (var i in fields) {
                  infoupdate[fields[i].name] = fields[i].value;
                }
                setDocumento(infoupdate);
              }}
            >
              <div className="row mt-3">
                <div className="col-12 col-md-3">
                  <Form.Item
                    className="no-margin"
                    label="Nombre"
                    name="nombre"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input style={{ width: "100%" }} />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-3">
                  <Form.Item
                    className="no-margin"
                    label="Tipo de documento"
                    name="tipo_documento"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar.."
                    >
                      {documentosGenerales.map(({ id, nombre }: any) => (
                        <Select.Option key={id} value={nombre}>
                          {nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Item
                    className="no-margin width-100 height-100"
                    label="Adjuntar documento"
                    name="url_documento"
                  >
                    <DocumentInput
                      doc={documento.url_documento}
                      fileInputRef={fileInputRef}
                      tipos_doc="PDF, DOCX, XLSX, JPG, PNG."
                      // setGuardoArchivo={setGuardoArchivo}
                      on_change={(e) => {
                        guardarArchivo(e);
                        e.target.value = "";
                      }}
                      onDelete={async () => {
                        setDocumento({ ...documento, url_documento: "" });
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    label="Descripción"
                    name="descripcion"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input.TextArea
                      maxLength={300}
                      showCount={true}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
                <div className="col-12 justify-content-flex-end">
                  <Button
                    className="button-azul-radius"
                    htmlType="submit"
                    form="documentosconvocatoriajurados"
                  >
                    Agregar
                  </Button>
                </div>
                <div className="col-12 font-size-14px font-family-Montserrat-Regular">
                  Documentación general asociadas
                </div>
                <div className="col-12">
                  <Table columns={columns} dataSource={documentos} pagination={false} />
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="me-md-2 button-blanco-radius"
              onClick={() =>
                props.cambiarPestaña({ ...props.activeItem, activeTab: "2" })
              }
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              onClick={guardarycontinuar}
            >
              Guardar y Continuar
            </Button>
          </div>
        </div>
      </div>
      <ModalVisualizarDocumentos
        visualizar={modalvisualizardocumento}
        setVisualizar={setModalVisualizarDocumento}
        state={{ documento: documentovisualizar }}
      />
      <ModalEditarDocumentos
        visualizar={modaleditardocumento}
        setVisualizar={setModalEditarDocumento}
        documento={documento}
        setDocumento={setDocumento}
        documentos={documentos}
        setDocumentos={setDocumentos}
        indexdocumento={indexdocumento}
      />
      <ModalWarning
        visualizar={modal_war}
        setVisualizar={setModal_war}
        onAceptar={onAceptar}
        titlle="Visualización de documento"
        description="Sin documento Adjunto"
        subdescription="Este registro no contiene un documento adjunto."
      />
    </>
  );
};
